import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Button, Tooltip, Slide } from '@material-ui/core';
import Info from "../../../../autom/editAction/components/Info";
import AppsOutlinedIcon from '@material-ui/icons/AppsOutlined';
import AccessAlarmOutlinedIcon from '@material-ui/icons/AccessAlarmOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import CategoryOutlinedIcon from '@material-ui/icons/CategoryOutlined';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import TouchAppRoundedIcon from '@material-ui/icons/TouchAppRounded';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import ExpandLessRounded from '@material-ui/icons/ExpandLessRounded';
import BugReportIcon from '@material-ui/icons/BugReport';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import ErrorSharpIcon from '@material-ui/icons/ErrorSharp';
import { libraryIcons } from '../../../../autom/NewFlowLibraryAssetManager';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import OptionsMenu from '../options/OptionsMenu';
import './Item.css';
import { useRecoilState, useSetRecoilState } from "recoil";
import { alertState, triggerConf, triggerSelection } from "../../../../../../../recoil-store/recoil-state";
import { capitalizeFirstLetter, conditionalOperators } from "../../../../../../../helpers/helper";
import Divider from '@material-ui/core/Divider';
import AutomService from "../../../../../../../services/AutomService/AutomService";

const defaultImage = "data:image/png;base64,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";

const Item = ({
    item,
    index,
    updateItems,
    handleDragStart,
    isConditionChild = false,
    conditionFlow,
    setActiveItem,
    setDetailTabs,
    detailTabs,
    deleteItem,
    isFocused,
    condition,
    groupable,
    hiddenParent,
    setDialog,
    getSelectedItems,
    debuggingStart,
    handleErrorOpenClick,
    handleErrorCloseClick,
    setShowTriggerRightArea,
    setOpenTriggerConfigure,
    setTriggerOffSet,
    openResetTriggerConfiguration,
    automDetail,
    setAutomDetail,
    setReCheck,
    reCheck,
    automaticallyVariableCreation,
    setTriggerModal,
    setOpenSchedule,
    updateVariableByItemId
}) => {
    const setAlert = useSetRecoilState(alertState);
    const { t } = useTranslation();
    const [expand, setExpand] = useState(false);
    const [actionLabel, setActionLabel] = useState(item?.label);
    const [changeLabel, setChangeLabel] = useState(false);

    const [openSetTriggerType, setOpenSetTriggerType] = useState(false);
    const ref = useRef(null);
    const refDebug = useRef(null);
    const nodeRef = useRef(null);
    const label = 'CONTENT.FLOW.'
    const triggerStaticTriggerLabel = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.TRIGGERS."
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);
    const [triggerSelectionData, setTriggerSelectionData] = useRecoilState(triggerSelection);

    useEffect(() => {
        horizontalLineStyleCalculator();
    }, []);

    const lineDefinition = item.actionName !== 'ELSEIF' && item.actionName !== 'ELSE' ? "horizontal-condition-row" : "horizontal-condition-row ml-60"

    const horizontalLineStyleCalculator = () => {
        const iconWidth = 60;
        const staticAdditionalWidth = 8;
        const staticAdditionalLeft = 5;
        const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
        Array.prototype.forEach.call(conditionHoverLines, function (el) {
            // Do stuff here
            const sEl = findAncestor(el, "horizontal-condition-row");
            const leftPosition = (sEl.offsetWidth / 2) + (iconWidth / 2) + staticAdditionalLeft;
            const actualWidth = (sEl.offsetWidth - leftPosition) + staticAdditionalWidth;
            el.style.width = actualWidth + "px";
            el.style.left = leftPosition + "px";
        });
    }

    function findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e?.target) {
            if (e?.target?.className.trim().includes('new-flow-drag-hover')) {
                e.target.style.border = '1px dashed #46474E';
            }
        }
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e?.target) {
            e.target.style.borderColor = 'transparent';
        }
    };

    const handleOnDrop = (e, direction, isFirstChild, copy, group) => {
        if (e?.stopPropagation) e.stopPropagation();
        if (e?.preventDefault) e.preventDefault();
        updateItems(index, item.name, item.id, direction, isFirstChild, copy, undefined, undefined, group);
    };

    const doNothing = (e) => {
        e.stopPropagation();
    }

    const openTriggerSelectionArea = () => {

    }

    const setTriggerArea = (e) => {
        e.stopPropagation();
        //setShowTriggerRightArea(true);
        let parent = ref.current.offsetParent;
        let left = ref.current.offsetLeft;
        let top = ref.current.offsetTop;
        while (parent.offsetParent) {
            left += parent.offsetLeft;
            top += parent.offsetTop;
            parent = parent.offsetParent;
        }

        setTriggerOffSet({
            left,
            top
        });

        setOpenTriggerConfigure(true);
        //setActiveItem(e, item);
    }

    const setTriggerType = async (type) => {

        let integrationType = "";
        let newFormData = {
            autom_id: automDetail.id,
            updatingFields: [
                { field_name: "name", field_value: automDetail.name },
                { field_name: "description", field_value: automDetail.description },
                { field_name: "mate_id", field_value: automDetail.mateId },
                { field_name: "queue_enabled", field_value: automDetail.queue_enabled },
                { field_name: "qpool_id", field_value: automDetail.queuePool },
                { field_name: "trigger_type", field_value: type }
            ]
        };

        if (type === "webhook" || type === "app" || type === "api" || type === "email") {
            integrationType = "TRIGGER";
        } else if (type === "schedule") {
            integrationType = "SCHEDULE";
        }

        newFormData.updatingFields.push({
            field_name: "integration_type",
            field_value: integrationType
        })

        const response = await AutomService.updateAutom(
            newFormData,
            automDetail.id
        );

        if (response.status) {
            let triggerSelectionData = [type];
            setAutomDetail({
                ...automDetail,
                trigger_type: type,
                integration_type: integrationType,
            });

            setTriggerSelectionData(triggerSelectionData);
            setReCheck(!reCheck);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(triggerStaticTriggerLabel + "TRIGGER-TYPE-SELECTED"),
                severity: 'success'
            }));

            // if integration type is a webhook or api, run function automaticallyVariableCreation
            if (type === "webhook" || type === "api") {
                automaticallyVariableCreation(type);
            }
            setOpenSetTriggerType(false);
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(triggerStaticTriggerLabel + "TRIGGER-TYPE-SELECTION-FAILED"),
                severity: 'error'
            }));
        }
    }

    const setTriggerSelection = (e) => {
        e.stopPropagation();
        setOpenSetTriggerType(true);
    }

    const handleSetActive = (e) => {
        e.stopPropagation();
        setShowTriggerRightArea(false);
        setActiveItem(e, item);
    };

    const handleDelete = (cut, isif) => {
        deleteItem(isif ? isif : item, cut);
    };

    const handleExpand = (e) => {
        e.stopPropagation();
        setExpand(!expand);
    };

    const handleResetTrigger = async (e) => {
        openResetTriggerConfiguration();
    }

    function handleDebugging(e, action) {
        e.stopPropagation();
        setActiveItem(e, action, 'debug');
    }

    const getExpandStyle = () => {
        if (expand) {
            return { minHeight: 0, paddingBottom: 0, background: 'transparent', boxShadow: 'none' };
        }
        if (item.hiddenParent) {
            return { padding: 0, background: 'transparent', boxShadow: 'none', minHeight: 0 };
        }
    };

    const getConditionStyle = () => {
        if (item.hiddenParent) {
            return { boxShadow: 'none', padding: 0, minHeight: 0, height: 0 };
        }
    };

    const handleErrorOpen = () => {
        handleErrorOpenClick(item?.debugErrorMessage);
    }

    const ConditionPicker2 = ({ condition, name, onClick }) => {
        const { t } = useTranslation();
        const label = 'CONTENT.CONFIGURATION-FORM.CONDITION.';
        return (
            <div className="condition-picker">
                <fieldset>
                    <legend>&nbsp;<span>{name}</span>&nbsp;</legend>
                    {/* <legend>&nbsp;<span>{condition.condition}</span>&nbsp;</legend> */}
                    <div>
                        <div>
                            <span className="condition-value">{condition.fields.firstValue.value}</span>
                            &nbsp;<span>{t(label + condition.operator.toUpperCase())}</span>&nbsp;
                            <span className="condition-value">{condition.fields.secondValue.value}</span>
                        </div>
                        {/* <div>
                            <button onClick={onClick}><MoreVertIcon /></button>
                        </div> */}
                    </div>
                </fieldset>
            </div>
        );
    }


    const ConditionPicker = ({ conditions, name }) => {
        const { t } = useTranslation();
        const label = 'CONTENT.CONFIGURATION-FORM.CONDITION.';
        return (

            <div className="condition-area">
                <div className="form-element wc">
                    <div className="condition-picker oe">
                        <fieldset>
                            <legend>&nbsp;<span>{name}</span>&nbsp;</legend>
                            {/* <legend>&nbsp;<span>{condition.condition}</span>&nbsp;</legend> */}
                            <div>
                                {
                                    conditions.map((condition, conditionI) => (
                                        <div>
                                            <span className="condition-value">{condition.fields.firstValue.value}</span>
                                            &nbsp;<span>{t(label + condition.operator.toUpperCase())}</span>&nbsp;
                                            <span className="condition-value">{condition.fields.secondValue.value}</span>
                                            {
                                                condition.logic !== 'last' &&
                                                <div className="form-element wc" style={{ textAlign: 'center' }}>
                                                    <div className="condition-tabs oe">
                                                        <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                            value="and" >
                                                            And
                                                        </button>
                                                        <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                            value="or">
                                                            Or
                                                        </button>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
        )
    }

    const doubleClick = (actionName) => {
        if (!changeLabel) {
            if (!actionLabel) {
                setActionLabel(actionName);
            }

            setChangeLabel(true);
        }
    }

    const onChangeLabel = (e) => {
        setActionLabel(e.target.value);
    }

    const saveLabel = (isCustomAction) => {
        setChangeLabel(false);
        let copyItems = JSON.parse(JSON.stringify(automDetail.items));
        let found = false;
        findAndSetLabel(copyItems, found)
        setAutomDetail({
            ...automDetail,
            items: copyItems
        });

        if (isCustomAction) {
            updateVariableByItemId(item.item_id, actionLabel);
        }
    }

    const findAndSetLabel = (items, found) => {
        for (const i in items) {
            if (items[i].item_id === item.item_id) {
                items[i].label = actionLabel;
                found = true;
                break;
            } else if (items[i].hasOwnProperty('children')) {
                items[i].children = findAndSetLabel(items[i].children, found);
                if (found) {
                    break;
                }
            }
        }
        return items;
    }

    const Standard = () => {
        return (
            <div className="new-flow-item-line"
                ref={ref}
                onDragOver={(e) => e.preventDefault()}
                onDragStart={(e) => handleDragStart(e, item, true)}
            >
                <div className={`option-container ${item?.item_id !== undefined ? item?.debugStatus : ""}`}
                    id={`${item?.item_id !== undefined ? 'act_' + item?.item_id : ''}`}
                    style={{ paddingLeft: 20, paddingRight: 20 }}>
                    <WarningRoundedIcon className="new-flow-warning-icon" id={'flow-warning' + item.id} />
                    {item.actionName !== 'START' && (
                        <Info value={t("CONTENT.FLOW.SHOW-ERROR")} placement="left">
                            <ErrorSharpIcon
                                onClick={handleErrorOpen}
                                className={`debug-error-icon ${item?.debugStatus === 'error' ? 'show' : ''}`}
                                id={'debug-error' + item.item_id} />
                        </Info>
                    )}

                    {item?.actionName === 'TRIGGER' && (Object.keys(triggerConfig.app).length > 0 || triggerSelectionData.length > 0) && (
                        <Tooltip placement="top" title={t(label + 'RESET-TRIGGER-CONFIG')}>
                            <IconButton
                                size='small'
                                style={{
                                    right: -8,
                                    top: -8,
                                    position: 'absolute',
                                    padding: 3,
                                    backgroundColor: "rgb(215, 94, 94)"
                                }}
                                onClick={(e) => handleResetTrigger(e)}
                            >
                                <RotateLeftIcon
                                    fontSize='small'
                                    style={{
                                        fontSize: 22,
                                        color: 'white',
                                        display: Object.keys(triggerConfig.app).length > 0 ? 'inline-block !important' : 'none !important'
                                    }}
                                />

                            </IconButton>
                        </Tooltip>
                    )}

                    {item?.actionName !== 'START' && item?.actionName !== 'STOP' && item?.actionName !== 'TRIGGER' && (
                        <IconButton size='small' style={{ left: 0, top: 0, position: 'absolute' }}
                            onClick={(e) => handleDebugging(e, item)}>
                            {debuggingStart && item?.actionName !== 'START' && item?.actionName !== 'STOP' &&
                                <BugReportIcon
                                    fontSize='small'
                                    style={{
                                        fontSize: 17,
                                        color: item.isDebugging ? '#D75E5E' : 'black',
                                        display: debuggingStart ? 'inline-block !important' : 'none !important'
                                    }}
                                />
                            }
                        </IconButton>
                    )}
                    {/* border-${item.libraryName.replace(/-/g, '_').replace(/ /g, '-').toLowerCase()} */}
                    <div
                        onClick={(e) => {
                            if (e.detail === 1) {
                                item.name !== 'TRIGGER' ? handleSetActive(e) : (triggerConfig && Object.keys(triggerConfig.app).length > 0 ? setTriggerArea(e) : doNothing(e))
                            }
                        }}
                        className={`action-icon-border ${getSelectedItems().find(i => i.id === item.id)
                            ? `action-selected border-active-action`
                            : 'border-transparent'}`}>
                        <div
                            id={item.name === 'START' ? 'flow-start' : item.name === 'STOP' ? 'flow-stop' : 'flow-regular'}
                            className={`new-flow-standard-item ${item.name === 'START' || item.name === 'STOP' ? 'start-stop-item' : ''} ${item.name === 'TRIGGER' && triggerConfig && Object.keys(triggerConfig.app).length > 0 ? 'trigger-app-icon' : ''} 
                            ${item.name === 'START' ? 'color-green' : item.name === 'STOP' ? 'color-red' : item.name === 'TRIGGER' ? (Object.keys(triggerConfig.app).length > 0 ? 'color-white' : 'color-blue') : 'color-white'}`
                            } draggable>
                            {
                                item.name === 'TRIGGER' && triggerConfig && Object.keys(triggerConfig.app).length > 0 ? (
                                    <img
                                        src={triggerConfig.app?.image_path}
                                        alt={triggerConfig.app?.name}
                                        className="selected-trigger-app" />
                                ) : (
                                    <div
                                        style={item.shade ? { backgroundColor: item.shade } : {}}
                                        className={`${item.shade ? '' : 'color-' + item.libraryName.replace(/-/g, '_').replace(/ /g, '-').toLowerCase()} ${item.name === 'START' || item.name === 'STOP' || item.name === 'TRIGGER' ? '' : item.action_label.includes('CUSTOM') ? 'item-icon color-white' : 'item-icon color-yellow'}`}>
                                        {/* {libraryIcons[item.libraryName.replace(/-/g, "_").toLowerCase()] ? libraryIcons[item.libraryName.replace(/-/g, "_").toLowerCase()] : */}
                                        {
                                            ['START', 'STOP', 'TRIGGER-STATIC'].find(x => x === item.libraryName) ? libraryIcons[item.libraryName.replace(/-/g, "_").toLowerCase()] :
                                                <img style={{ width: 30 }} alt={item.libraryName}
                                                    src={`${item.image}`} />
                                        }
                                    </div>
                                )
                            }
                            {
                                item?.library_label?.includes('CUSTOM') ?
                                    (
                                        <div onClick={(e) => e.detail === 2 ? doubleClick(item?.action_name) : undefined} className={`${item.conditions && item.conditions.length && "wc"}  action-item`}
                                            style={{ textAlign: "center", position: "relative" }}>
                                            <span className="action-item-lib">{item?.library_name}</span>
                                            {!changeLabel ?
                                                <span className="action-item-action">{actionLabel ? actionLabel : item?.action_name}</span> :
                                                <input style={{ border: '0' }} className="action-item-action" onBlur={() => saveLabel(true)} autoFocus type="text" value={actionLabel} onChange={onChangeLabel} />
                                            }
                                            {
                                                item.conditions && item.conditions.length > 0 && (
                                                    <div className="field-condition-section">
                                                        <span className="field-condition-title">Conditions</span>
                                                        {item.conditions.map(fieldName => {
                                                            return item.fields[fieldName].functions.map(f => f.conditions && <ConditionPicker conditions={f.conditions} name={f.name} />)
                                                            // return item.fields[fieldName].functions.map(f => f.conditions && f.conditions.map((condition, conditionI) =>
                                                            //     <div className="condition-area" key={conditionI}>
                                                            //         <div className="form-element wc">
                                                            //             <ConditionPicker condition={condition} name={f.name} onClick={(e) => { }} />
                                                            //         </div>
                                                            //         {condition.logic !== 'last' &&
                                                            //             <div className="form-element wc" style={{ textAlign: 'center' }}>
                                                            //                 <div className="condition-tabs">
                                                            //                     <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                            //                         value="and" onClick={(e) => { }}>
                                                            //                         And
                                                            //                     </button>
                                                            //                     <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                            //                         value="or" onClick={(e) => { }}>
                                                            //                         Or
                                                            //                     </button>
                                                            //                 </div>
                                                            //             </div>
                                                            //         }
                                                            //     </div>
                                                            // ))
                                                            // return item.fields[fieldName].conditions.map(conditions => conditions.map((condition, conditionI) =>
                                                            //     <div className="condition-area" key={conditionI}>
                                                            //         <div className="form-element wc">
                                                            //             <ConditionPicker condition={condition} onClick={(e) => { }} />
                                                            //         </div>
                                                            //         {condition.logic !== 'last' &&
                                                            //             <div className="form-element wc" style={{ textAlign: 'center' }}>
                                                            //                 <div className="condition-tabs">
                                                            //                     <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                            //                         value="and" onClick={(e) => { }}>
                                                            //                         And
                                                            //                     </button>
                                                            //                     <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                            //                         value="or" onClick={(e) => { }}>
                                                            //                         Or
                                                            //                     </button>
                                                            //                 </div>
                                                            //             </div>
                                                            //         }
                                                            //     </div>
                                                            // ))
                                                        })}
                                                    </div>
                                                )

                                                // item.fields &&
                                                // Object.keys(item.fields).filter(key => item.fields[key].conditions && item.fields[key].conditions.length)?.map(fieldKey => {
                                                //     return item.fields[fieldKey].conditions.map(conditions => conditions.map((condition, conditionI) =>

                                                //         <div key={conditionI}>
                                                //             <div className="form-element">
                                                //                 <ConditionPicker condition={condition} onClick={(e) => { }} />
                                                //             </div>
                                                //             {condition.logic !== 'last' &&
                                                //                 <div className="form-element" style={{ textAlign: 'center' }}>
                                                //                     <div className="condition-tabs">
                                                //                         <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                //                             value="and" onClick={(e) => { }}>
                                                //                             And
                                                //                         </button>
                                                //                         <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                //                             value="or" onClick={(e) => { }}>
                                                //                             Or
                                                //                         </button>
                                                //                     </div>
                                                //                 </div>
                                                //             }
                                                //         </div>
                                                //     ))
                                                // })
                                            }
                                        </div>

                                    ) :
                                    (
                                        <div
                                            onClick={(e) => {
                                                if (e.detail === 2) {
                                                    if (item.name !== 'START' && item.name !== 'STOP' && item.name !== 'TRIGGER') {
                                                        const name = t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);
                                                        doubleClick(name)
                                                    }
                                                }
                                            }}
                                            className={`${item.conditions && item.conditions.length && "wc"} ${(item.name === 'STOP' || item.name === 'START') ? 'action-item-ss' : item.name !== 'TRIGGER' ? 'action-item' : ''}`}
                                            style={{ textAlign: "center", position: "relative" }}>
                                            {item.name !== 'START' && item.name !== 'STOP' && item.name !== 'TRIGGER' &&
                                                <span
                                                    className="action-item-lib">{t(`CONTENT.LIBRARY.${item.libraryName}.NAME`)}
                                                </span>
                                            }
                                            {
                                                item.name !== 'TRIGGER' && (
                                                    changeLabel && item.name !== 'START' && item.name !== 'STOP' ?
                                                        <input style={{ border: '0', minWidth: '60px', maxWidth: '100%' }} className="action-item-action" onBlur={() => saveLabel(false)} autoFocus type="text" value={actionLabel} onChange={onChangeLabel} /> :
                                                        <span
                                                            className={`${item.name !== 'START' && item.name !== 'STOP' ? 'action-item-action' : 'action-item-sss'}`}>{actionLabel ? actionLabel : t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`)}
                                                        </span>
                                                )
                                            }
                                            {
                                                item.conditions && item.conditions.length > 0 && (
                                                    <div className="field-condition-section">
                                                        <span className="field-condition-title">Conditions</span>
                                                        {item.conditions.map(fieldName => {
                                                            return item.fields[fieldName].functions.map(f => f.conditions && <ConditionPicker conditions={f.conditions} name={f.name} />)
                                                        })}
                                                    </div>
                                                )

                                                // item.fields &&
                                                // Object.keys(item.fields).filter(key => item.fields[key].conditions && item.fields[key].conditions.length)?.map(fieldKey => {
                                                //     return item.fields[fieldKey].conditions.map(conditions => conditions.map((condition, conditionI) =>

                                                //         <div key={conditionI}>
                                                //             <div className="form-element">
                                                //                 <ConditionPicker condition={condition} onClick={(e) => { }} />
                                                //             </div>
                                                //             {condition.logic !== 'last' &&
                                                //                 <div className="form-element" style={{ textAlign: 'center' }}>
                                                //                     <div className="condition-tabs">
                                                //                         <button className={condition.logic === 'and' ? 'condition-active' : ''}
                                                //                             value="and" onClick={(e) => { }}>
                                                //                             And
                                                //                         </button>
                                                //                         <button className={condition.logic === 'or' ? 'condition-active' : ''}
                                                //                             value="or" onClick={(e) => { }}>
                                                //                             Or
                                                //                         </button>
                                                //                     </div>
                                                //                 </div>
                                                //             }
                                                //         </div>
                                                //     ))
                                                // })
                                            }
                                        </div>
                                    )
                            }
                        </div>
                    </div>
                    {item.actionName !== 'STOP' && item.actionName !== 'TRIGGER' &&
                        <OptionsMenu item={item}
                            selectedItem={item}
                            index={index} setDialog={setDialog}
                            options={{
                                cut: (e) => handleDragStart(e, item, true, true),
                                copy: (e) => handleDragStart(e, item, undefined, true),
                                paste: (e) => handleOnDrop(e, undefined, undefined, true, groupable),
                                delete: handleDelete
                            }}
                            isCondition={item.flow_behavior?.includes('groupable')} />
                    }
                </div>
                {
                    item.name === 'TRIGGER' &&
                    <div className="new-flow-row">
                        <div className="trigger-panel">
                            <h4>
                                {triggerSelectionData.length > 0 ?
                                    (
                                        <div className="trigger-type-section">
                                            {triggerSelectionData.map((item) => {
                                                return (
                                                    item === "app" ? (
                                                        <Tooltip title={t(triggerStaticTriggerLabel + "APP")}
                                                            placement="top">
                                                            <span className="trigger-type"><AppsOutlinedIcon /></span>
                                                        </Tooltip>
                                                    ) : item === "webhook" ? (
                                                        <Tooltip title={t(triggerStaticTriggerLabel + "WEBHOOK")}
                                                            placement="top">
                                                            <span className="trigger-type"><TouchAppRoundedIcon /></span>
                                                        </Tooltip>
                                                    ) : item === "email" ? (
                                                        <Tooltip title={t(triggerStaticTriggerLabel + "EMAIL")}
                                                            placement="top">
                                                            <span className="trigger-type"><EmailOutlinedIcon /></span>
                                                        </Tooltip>
                                                    ) : item === "api" ? (
                                                        <Tooltip title={t(triggerStaticTriggerLabel + "API")}
                                                            placement="top">
                                                            <span
                                                                className="trigger-type"><CategoryOutlinedIcon /></span>
                                                        </Tooltip>
                                                    ) : item === "schedule" ? (
                                                        <Tooltip title={t(triggerStaticTriggerLabel + "SCHEDULE")}
                                                            placement="top">
                                                            <span
                                                                className="trigger-type"><AccessAlarmOutlinedIcon /></span>
                                                        </Tooltip>
                                                    ) : null
                                                )
                                            })}
                                        </div>
                                    ) :
                                    (
                                        t(triggerStaticTriggerLabel + 'TRIGGER')
                                    )
                                }
                            </h4>
                            {
                                triggerSelectionData.length > 0 ? (
                                    triggerSelectionData.includes('app') ? (
                                        triggerConfig && Object.keys(triggerConfig.trigger).length > 0 ? (
                                            <div className='trigger-item-container'>
                                                <div
                                                    className="trigger-pane">{t(triggerStaticTriggerLabel + triggerConfig.trigger?.name)} ({capitalizeFirstLetter(triggerConfig.trigger?.type)})
                                                </div>
                                                {triggerConfig.setup.conditions?.length > 0 && triggerConfig.setup.conditions[0].condition !== "" && (
                                                    <div className="add-trigger-setup-block">
                                                        {triggerConfig.setup.conditions.map((item, i) => {
                                                            let prevItem;
                                                            if (i - 1 >= 0) prevItem = triggerConfig.setup.conditions[i - 1];
                                                            return (
                                                                <>
                                                                    {item.source.length > 0 && item.condition !== "" && (
                                                                        <>
                                                                            {prevItem && prevItem.op_logic && prevItem.source.length > 0 && prevItem.condition !== "" && (
                                                                                <div className="op-logic-area">
                                                                                    {prevItem.op_logic.toUpperCase()}
                                                                                </div>
                                                                            )}
                                                                            <div key={i}
                                                                                className="condition-block">
                                                                                <div className="source-area">
                                                                                    <span className="if-block">
                                                                                        {`# ${i + 1} ` + t("CONTENT.FLOW.CONDITION")}
                                                                                    </span>
                                                                                    <span
                                                                                        className="if-selection source-datas">
                                                                                        <div
                                                                                            className='condition-source-container'>
                                                                                            {
                                                                                                item.source?.map((v, i) => {
                                                                                                    return <div
                                                                                                        className="source-param">{v.text}</div>
                                                                                                })
                                                                                            }
                                                                                        </div>

                                                                                        <div
                                                                                            className="condition-param">{conditionalOperators[item.condition]?.text}</div>
                                                                                    </span>
                                                                                    {item.condition !== "e" && item.condition !== "ne" && item.target !== "" && (
                                                                                        <>
                                                                                            <Divider
                                                                                                style={{ backgroundColor: '#e6e6e6' }} />
                                                                                            <span
                                                                                                className="if-selection">
                                                                                                <div
                                                                                                    className="source-param">{item.target}</div>
                                                                                            </span>
                                                                                        </>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div>
                                                <Button onClick={setTriggerArea} className='trigger-button'
                                                    variant="contained">
                                                    {t(triggerStaticTriggerLabel + 'CONFIGURE-TRIGGER')}
                                                </Button>
                                            </div>
                                        )
                                    ) : triggerSelectionData.includes('webhook') || triggerSelectionData.includes('api') || triggerSelectionData.includes('email') ? (
                                        <div>
                                            <Button onClick={setTriggerModal} className='trigger-button'
                                                variant="contained">
                                                {t(triggerStaticTriggerLabel + 'CONFIGURE-TRIGGER')}
                                            </Button>
                                        </div>
                                    ) : triggerSelectionData.includes('schedule') ? (
                                        <div>
                                            <Button onClick={setOpenSchedule} className='trigger-button'
                                                variant="contained">
                                                {t(triggerStaticTriggerLabel + 'CONFIGURE-TRIGGER')}
                                            </Button>
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                ) : (
                                    <div style={{ position: "relative" }}>
                                        <Button onClick={setTriggerSelection} className='trigger-button'
                                            variant="contained">
                                            {t(triggerStaticTriggerLabel + 'SET-TRIGGER-TYPE')}
                                        </Button>
                                        <Slide direction="left" in={openSetTriggerType} mountOnEnter
                                            unmountOnExit>
                                            <div ref={nodeRef}
                                                className={`trigger-selection-area ${openSetTriggerType ? "active" : ""}`}>
                                                <div className="trigger-selection-item"
                                                    onClick={() => setTriggerType("app")}>
                                                    <AppsOutlinedIcon />
                                                    <span>{t(triggerStaticTriggerLabel + "APP")}</span>
                                                </div>
                                                <div className="trigger-selection-item"
                                                    onClick={() => setTriggerType("webhook")}>
                                                    <TouchAppRoundedIcon />
                                                    <span>{t(triggerStaticTriggerLabel + "WEBHOOK")}</span>
                                                </div>
                                                <div className="trigger-selection-item"
                                                    onClick={() => setTriggerType("api")}>
                                                    <CategoryOutlinedIcon />
                                                    <span>{t(triggerStaticTriggerLabel + "API")}</span>
                                                </div>
                                                <div className="trigger-selection-item"
                                                    onClick={() => setTriggerType("email")}>
                                                    <EmailOutlinedIcon />
                                                    <span>{t(triggerStaticTriggerLabel + "EMAIL")}</span>
                                                </div>
                                                <div className="trigger-selection-item"
                                                    onClick={() => setTriggerType("schedule")}>
                                                    <AccessAlarmOutlinedIcon />
                                                    <span>{t(triggerStaticTriggerLabel + "SCHEDULE")}</span>
                                                </div>
                                                <div className="trigger-selection-close"
                                                    onClick={() => setOpenSetTriggerType(false)}>
                                                    <CancelOutlinedIcon
                                                        style={{ fontSize: 35, color: "#f67575" }} />
                                                </div>
                                            </div>
                                        </Slide>
                                    </div>
                                )
                            }
                        </div>
                    </div>





                    // <div className="new-flow-row">
                    //     <div className="trigger-panel">
                    //         <h4>{t(triggerStaticTriggerLabel + 'TRIGGER')}</h4>
                    //         {Object.keys(triggerConfig.app).length === 0 && (
                    //             // <div className="add-trigger-block">
                    //             //    {/* <Tooltip title={t(label + 'ADD-TRIGGER')}>
                    //             //     <AddIcon className="line-color trigger-add" onClick={setTriggerArea}/>
                    //             // </Tooltip> */}
                    //             // </div> 
                    //             <div>

                    //                 <Button onClick={setTriggerArea} className='trigger-button' variant="contained">Configure Trigger</Button>
                    //             </div>

                    //         )}
                    //         {Object.keys(triggerConfig.app).length > 0 && (
                    //             <div className="add-trigger-block" onClick={setTriggerArea}>
                    //                 <img src={triggerConfig.app?.image_path} alt={triggerConfig.app?.name}
                    //                     className="selected-app" />
                    //             </div>
                    //         )}
                    //         {Object.keys(triggerConfig.trigger).length > 0 && (
                    //             <div className="add-trigger-trigger-block">
                    //                 <div
                    //                     className="trigger-pane">{t(triggerStaticTriggerLabel + triggerConfig.trigger?.name)} ({capitalizeFirstLetter(triggerConfig.trigger?.type)})
                    //                 </div>
                    //                 {triggerConfig.setup.conditions?.length > 0 && triggerConfig.setup.conditions[0].condition !== "" && (
                    //                     <div className="add-trigger-setup-block">
                    //                         <div className="separator-line" />
                    //                         {triggerConfig.setup.conditions.map((item, i) => {
                    //                             let prevItem;
                    //                             if (i - 1 >= 0) prevItem = triggerConfig.setup.conditions[i - 1];
                    //                             return (
                    //                                 <>
                    //                                     {item.source.length > 0 && item.condition !== "" && (
                    //                                         <>
                    //                                             {prevItem && prevItem.op_logic && prevItem.source.length > 0 && prevItem.condition !== "" && (
                    //                                                 <div className="op-logic-area">
                    //                                                     {prevItem.op_logic.toUpperCase()}
                    //                                                 </div>
                    //                                             )}
                    //                                             <div key={i} className="condition-block">
                    //                                                 <div className="source-area">
                    //                                                     <span className="if-block">
                    //                                                         <span>
                    //                                                             {i + 1}
                    //                                                         </span>
                    //                                                         {t(label + "CONDITION")}
                    //                                                     </span>
                    //                                                     <span className="if-selection">
                    //                                                         {
                    //                                                             item.source?.map((v, i) => {
                    //                                                                 return <span
                    //                                                                     className="source-param">{v.text}</span>
                    //                                                             })
                    //                                                         }
                    //                                                         <span
                    //                                                             className="condition-param">{conditionalOperators[item.condition]?.text}</span>
                    //                                                     </span>
                    //                                                     {item.condition !== "e" && item.condition !== "ne" && item.target !== "" && (
                    //                                                         <div className="target-area">{item.target}</div>
                    //                                                     )}
                    //                                                 </div>

                    //                                             </div>
                    //                                         </>
                    //                                     )}
                    //                                 </>
                    //                             )
                    //                         })}
                    //                     </div>
                    //                 )}
                    //             </div>
                    //         )}

                    //     </div>
                    // </div>
                }
                {
                    item.name !== 'STOP' && item.name !== 'TRIGGER' &&
                    <div>
                        <div
                            className={`new-flow-line new-flow-vertical-line ${groupable?.children?.length - 1 === index ? "first-child" : ""}`} />
                        <div
                            style={{
                                width: '150px',
                                display: item.hiddenParent ? 'none' : 'flex',
                                justifyContent: 'center',
                                border: "1px solid transparent",
                                height: 30,
                                marginTop: "-54px",
                                zIndex: 9999,
                                position: "absolute",
                                left: "50%",
                                marginLeft: "-75px",
                                alignItems: "center"
                            }}
                            className={`new-flow-drag-hover ${groupable?.children?.length > 0 && index >= 0 ? "bottom-draggable-area" : ""}`}
                            onDragEnter={(e) => handleDragEnter(e)}
                            onDragLeave={(e) => handleDragLeave(e)}
                            onDrop={(e) => handleOnDrop(e, undefined, undefined, undefined, groupable)}
                        >
                        </div>
                    </div>
                }
            </div >
        );
    };

    const Groupable = () => {
        return (
            <div className="groupable-flow-container"
                style={{ gridAutoFlow: item.flow_behavior.includes('horizontal') ? 'column' : 'row' }}>
                <div className="new-flow-item-line"
                    onDragStart={(e) => handleDragStart(e, item, true)}
                    onDragOver={(e) => e.preventDefault()}
                >
                    <div className={lineDefinition + " new-flow-horizontal-item-line"}>
                        <div style={{
                            ...getExpandStyle(),
                            textAlign: 'center'
                        }}
                            className="new-flow-groupable-item"
                            draggable
                        >
                            <div id={`${item?.item_id !== undefined ? 'act_' + item?.item_id : ''}`}
                                className={item.type === 'groupable' ? `option-container groupable ${item?.item_id !== undefined ? item?.debugStatus : ""}` : "option-container " + (item?.item_id !== undefined ? item.debugStatus : "")}
                                style={{
                                    marginBottom: 10,
                                    display: item.hiddenParent ? 'none' : undefined
                                }}>
                                <WarningRoundedIcon className="new-flow-warning-icon" id={'flow-warning' + item.id} />
                                {item.actionName !== 'START' && (
                                    <Info value={t("CONTENT.FLOW.SHOW-ERROR")} placement="left">
                                        <ErrorSharpIcon
                                            onClick={handleErrorOpen}
                                            className={`debug-error-icon ${item?.debugStatus === 'error' ? 'show' : ''}`}
                                            id={'debug-error' + item.item_id} />
                                    </Info>
                                )}
                                {(item.actionName !== 'IF' && item.actionName !== 'ELSEIF' && item.actionName !== 'ELSE') &&
                                    <IconButton className="option-icon" onClick={handleExpand} size="small"
                                        style={{ position: 'absolute', top: 0, left: -1 }}>
                                        <ExpandLessRounded fontSize='small'
                                            style={{
                                                color: 'black',
                                                transform: expand ? 'rotate(180deg)' : 'rotate(0deg)'
                                            }}
                                        />
                                    </IconButton>
                                }
                                {/* border-${item.libraryName.replace(/-/g, '_').replace(/ /g, '-').toLowerCase()} */}
                                <div className={`option-row ${getSelectedItems().find(i => i.id === item.id)
                                    ? `action-selected border-active-action`
                                    : 'border-transparent'}`} onClick={(e) => {
                                        if (e.detail === 1) {
                                            handleSetActive(e);
                                        }
                                    }}>
                                    <div
                                        style={item.shade ? { backgroundColor: item.shade } : {}}
                                        className={`action-icon-border if ${item.name.toLowerCase()}-${item.conditionGroupId ? item.conditionGroupId : "group"}`}>
                                        <img style={{ width: 30 }} alt={item.libraryName}
                                            src={`${item.image}`} />
                                    </div>

                                    {!item.hiddenParent && <OptionsMenu item={item}
                                        selectedItem={item} setDialog={setDialog}
                                        index={index}
                                        condition={condition}
                                        setDetailTabs={setDetailTabs}
                                        detailTabs={detailTabs}
                                        options={{
                                            cut: (e) => handleDragStart(e, item, true, true),
                                            copy: (e) => handleDragStart(e, item, undefined, true),
                                            paste: (e, first) => handleOnDrop(e, undefined, first, true, groupable),
                                            delete: handleDelete
                                        }}
                                        isCondition={item.flow_behavior?.includes('groupable')} />}
                                    <div onClick={(e) => {
                                        if (e.detail === 2) {
                                            let name;
                                            if ((item.action_name === 'GROUP' || item.action_name === 'BUTTON-SCOPE' || item.action_name === 'LIST-SCOPE' || item.action_name === 'TEXT')
                                                && item.fields?.label?.value) {
                                                name = item.fields.label.value
                                            } else {
                                                name = t('CONTENT.LIBRARY.' + item.libraryName + '.ACTION.' + item.name)
                                            }
                                            doubleClick(name)
                                        }
                                    }} className="new-flow-groupable-title action-item">
                                        <span className="action-item-lib">
                                            {t(`CONTENT.LIBRARY.${item.libraryName}.NAME`)}
                                        </span>
                                        {!changeLabel ?
                                            <span className="action-item-action">
                                                {actionLabel ? actionLabel :
                                                    (item.action_name === 'GROUP' || item.action_name === 'BUTTON-SCOPE' || item.action_name === 'LIST-SCOPE' || item.action_name === 'TEXT')
                                                        && item.fields?.label?.value ?
                                                        item.fields.label.value :
                                                        t('CONTENT.LIBRARY.' + item.libraryName + '.ACTION.' + item.name)}
                                            </span> :
                                            <input style={{ border: '0' }} className="action-item-action" onBlur={() => saveLabel(false)} autoFocus type="text" value={actionLabel} onChange={onChangeLabel} />
                                        }
                                    </div>
                                    {debuggingStart &&
                                        <IconButton size="small" onClick={(e) => handleDebugging(e, item)}
                                            style={{
                                                left: 0,
                                                top: item.name === 'IF' || item.name === 'ELSEIF' || item.name === 'ELSE' ? 2 : 20,
                                                position: 'absolute'
                                            }}>
                                            <BugReportIcon style={{
                                                fontSize: 18, color: item.isDebugging ? '#D75E5E' : 'black',
                                                display: 'inline-block !important'
                                            }} ref={refDebug} />
                                        </IconButton>}
                                </div>
                            </div>
                            <div
                                className={`${item.flow_behavior.includes('horizontal') ? 'groupable-horizontal-scope' : 'groupable-scope'}`}
                                style={{
                                    display: expand ? 'none' : 'flex',
                                    flexDirection: item.flow_behavior.includes('horizontal') ? 'row' : 'column',
                                    position: "relative",
                                    marginTop: "30px",
                                    marginBottom: "30px"
                                }}>
                                {<>
                                    {item.children && item.children.length > 0 ? <div
                                        style={{
                                            width: '150px',
                                            display: item.hiddenParent ? 'none' : 'flex',
                                            justifyContent: 'center',
                                            border: "1px solid transparent",
                                            height: 30,
                                            top: "-41px",
                                            zIndex: 9999,
                                            position: "absolute",
                                            left: "50%",
                                            marginLeft: "-75px"
                                        }}
                                        className="new-flow-drag-hover"
                                        onDrop={(e) => handleOnDrop(e, '', true, undefined, item)}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDragEnter={(e) => handleDragEnter(e)}
                                        onDragLeave={(e) => handleDragLeave(e)}
                                    >

                                    </div> : !item.hiddenParent && <div className="new-flow-drop-zone"
                                        onDrop={(e) => handleOnDrop(e, '', true, undefined, item)}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDragEnter={(e) => e.target.style.borderColor = 'red'}
                                        onDragLeave={(e) => e.target.style.borderColor = 'teal'}>
                                        {t('CONTENT.FLOW.DROP')}
                                    </div>}
                                    {item.children && item.children.length > 0 && item.children.map((subItem, i) => (!subItem?.hidden &&
                                        <Item key={subItem.id} item={subItem} index={i} groupable={item}
                                            updateItems={updateItems} handleDragStart={handleDragStart}
                                            isConditionChild={false} setDetailTabs={setDetailTabs}
                                            conditionFlow={conditionFlow} hiddenParent={item.hiddenParent}
                                            setActiveItem={setActiveItem} detailTabs={detailTabs}
                                            deleteItem={deleteItem} setDialog={setDialog}
                                            getSelectedItems={getSelectedItems}
                                            isFocused={false} debuggingStart={debuggingStart}
                                            setShowTriggerRightArea={setShowTriggerRightArea}
                                            handleErrorOpenClick={handleErrorOpenClick}
                                            automDetail={automDetail}
                                            updateVariableByItemId={updateVariableByItemId}
                                            setAutomDetail={setAutomDetail} />
                                    ))}
                                </>}
                            </div>
                        </div>
                        {item.name !== 'ELSE' && conditionFlow !== 'row' &&
                            <div>
                                <div
                                    className={"new-flow-line new-flow-horizontal-line-condition " + item.name.toLowerCase()}
                                    onDrop={(e) => handleOnDrop(e, 'column', undefined, undefined, groupable)}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDragEnter={(e) => e.preventDefault()}
                                />
                                <div
                                    className={"new-flow-drag-hover new-flow-drag-hover-condition " + item.name.toLowerCase()}
                                    onDrop={(e) => handleOnDrop(e, 'column', undefined, undefined, groupable)}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDragEnter={(e) => handleDragEnter(e)}
                                    onDragLeave={(e) => handleDragLeave(e)}
                                    style={{
                                        width: "100%",
                                        display: item.hiddenParent ? 'none' : 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: 30,
                                        border: "1px solid transparent",
                                        zIndex: 9999
                                    }}>
                                </div>
                            </div>
                        }
                        {/*{isConditionChild && conditionFlow !== 'row' && item.name !== 'ELSE' &&*/}
                        {/*<div>*/}
                        {/*    <div*/}
                        {/*        className={"new-flow-line new-flow-horizontal-line-condition " + item.name.toLowerCase()}*/}
                        {/*        condgroupid={item.conditionGroupId}*/}
                        {/*        onDrop={(e) => handleOnDrop(e, 'column')}*/}
                        {/*        onDragOver={(e) => e.preventDefault()}*/}
                        {/*        onDragEnter={(e) => e.preventDefault()}*/}
                        {/*    />*/}
                        {/*    <div*/}
                        {/*        className={"new-flow-drag-hover new-flow-drag-hover-condition " + item.name.toLowerCase()}*/}
                        {/*        condgroupid={item.conditionGroupId}*/}
                        {/*        onDrop={(e) => handleOnDrop(e, 'column')}*/}
                        {/*        onDragOver={(e) => e.preventDefault()}*/}
                        {/*        onDragEnter={(e) => handleDragEnter(e)}*/}
                        {/*        onDragLeave={(e) => handleDragLeave(e)}*/}
                        {/*        style={{*/}
                        {/*            width: "100%",*/}
                        {/*            display: item.hiddenParent ? 'none' : 'flex',*/}
                        {/*            justifyContent: 'center',*/}
                        {/*            alignItems: 'center',*/}
                        {/*            height: 30,*/}
                        {/*            border: "1px solid transparent",*/}
                        {/*            zIndex: 9999*/}
                        {/*        }}>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*}*/}
                    </div>
                    {(!isConditionChild || conditionFlow !== 'column') && item.name !== 'ELSE' && item.name !== 'LIST-ITEM' && item.name !== 'BUTTON-ITEM' &&
                        !isFocused &&
                        <div>
                            <div
                                className={`new-flow-line new-flow-vertical-line ${groupable?.children?.length - 1 === index ? "first-child" : ""}`}
                                onDrop={(e) => handleOnDrop(e, 'row')}
                                onDragOver={(e) => e.preventDefault()}
                                onDragEnter={(e) => e.preventDefault()}
                            />
                            <div className="new-flow-drag-hover"
                                onDragEnter={(e) => handleDragEnter(e)}
                                onDragLeave={(e) => handleDragLeave(e)}
                                onDrop={(e) => handleOnDrop(e, 'row')}
                                style={{
                                    width: '150px',
                                    display: item.hiddenParent ? 'none' : 'flex',
                                    justifyContent: 'center',
                                    border: "1px solid transparent",
                                    height: 30,
                                    marginTop: "-54px",
                                    zIndex: 9999,
                                    position: "absolute",
                                    left: "50%",
                                    marginLeft: "-75px"
                                }}>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    };
    const Condition = () => {
        return (
            <div
                onDragStart={(e) => handleDragStart(e, item, true)}
                onDragOver={(e) => e.preventDefault()}
                className={` new-flow-item-line ${item.flow === 'column' ? 'justify-content-start' : 'justify-content-center'}`}>
                <div className="new-flow-groupable-item groupable-container option-condition new-flow-condition-color"
                    draggable style={{ gridAutoFlow: item.flow, position: 'relative', ...getConditionStyle() }}
                >
                    {item.children &&
                        item.children.map((subItem, i) =>
                            <Item key={subItem.id} item={subItem} index={i} condition={item}
                                updateItems={updateItems} handleDragStart={handleDragStart}
                                isConditionChild={true} setDetailTabs={setDetailTabs}
                                conditionFlow={item.flow} hiddenParent={subItem.hiddenParent}
                                setActiveItem={setActiveItem} setDialog={setDialog}
                                deleteItem={deleteItem} detailTabs={detailTabs} groupable={item}
                                isFocused={false} debuggingStart={debuggingStart}
                                getSelectedItems={getSelectedItems}
                                setShowTriggerRightArea={setShowTriggerRightArea}
                                handleErrorOpenClick={handleErrorOpenClick}
                                automDetail={automDetail}
                                updateVariableByItemId={updateVariableByItemId}
                                setAutomDetail={setAutomDetail}
                            />
                        )}
                    {!item.hiddenParent && <OptionsMenu item={item}
                        setDetailTabs={setDetailTabs}
                        detailTabs={detailTabs}
                        selectedItem={item} setDialog={setDialog}
                        index={index}
                        options={{
                            cut: (e) => handleDragStart(e, item, true, true),
                            copy: (e) => handleDragStart(e, item, undefined, true),
                            paste: (e) => handleOnDrop(e, undefined, undefined, true),
                            delete: handleDelete
                        }}
                        isCondition={item.flow_behavior?.includes('groupable')} />}
                </div>
                {!isFocused &&
                    <div>
                        <div
                            className={`new-flow-line new-flow-vertical-line ${groupable?.children?.length - 1 === index ? "first-child" : ""}`}
                            onDrop={(e) => handleOnDrop(e)}
                            onDragOver={(e) => e.preventDefault()}
                            onDragEnter={(e) => e.preventDefault()} />
                        <div
                            className="new-flow-drag-hover"
                            onDragEnter={(e) => handleDragEnter(e)}
                            onDragLeave={(e) => handleDragLeave(e)}
                            onDrop={(e) => {
                                handleOnDrop(e);
                            }}
                            style={{
                                width: "150px",
                                display: hiddenParent ? 'none' : 'flex',
                                justifyContent: 'center',
                                border: "1px solid translate",
                                height: 30,
                                marginTop: "-54px",
                                zIndex: 9999,
                                position: "absolute",
                                left: "50%",
                                marginLeft: "-75px"
                            }}>
                        </div>
                    </div>
                }
            </div>
        );
    };

    return (
        <>
            {item.type === 'standard' && <Standard />}
            {item.type === 'groupable' && <Groupable />}
            {item.type === 'condition' && <Condition />}
        </>
    );
};
export default Item;
